<template>
  <div class="form-layout">
    <div class="form-layout__form">
      <slot name="default"></slot>
    </div>
    <div class="form-layout__bottom-bar" v-if="$slots['bottom-bar']">
      <slot name="bottom-bar"> </slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>
